import { sharedShowApi } from '@/api/sharedShowApi'
import { api } from '@/api/client'
import { demoAuth } from '@/api/demoAuth'
import { endpoints } from '@/api/endpoints'
import type { LoginInput } from '@/features/auth/schemas/authSchemas'
import type { Session } from '@/features/auth/types'
import { env } from '@/lib/env'

export const authApi = {
  login: (input: LoginInput) =>
    env.sharedShow
      ? sharedShowApi.login(input)
      : env.demoMode
        ? demoAuth.login(input)
        : api.post<Session>(endpoints.session, input),

  /** The answer is a whole new session: new location, new `today`, new cookie and CSRF token. */
  switchLocation: (location: string) =>
    env.sharedShow
      ? sharedShowApi.switchLocation(location)
      : env.demoMode
        ? demoAuth.switchLocation(location)
        : api.put<Session>(endpoints.sessionLocation, { location }),

  logout: () =>
    env.sharedShow
      ? sharedShowApi.logout()
      : env.demoMode
        ? demoAuth.logout()
        : api.delete<void>(endpoints.session),
}
